import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {TerceroUPPasarelaTarifa} from '../_models/tercero-up-pasarela-tarifa';

@Injectable({
  providedIn: 'root'
})
export class TerceroUpPasarelaTarifaService {
  private rutServicio = AppSettings.rutServiciosTER + '/api/tercerosUPPasarelasTarifas';

  constructor(private httClient: HttpClient) {
  }

  listMetodosPasarelaTarifas(idTerceroUPPasarelaProducto: string) {
    return this.httClient.get(`${this.rutServicio}/listMetodosPasarelaTarifas/${idTerceroUPPasarelaProducto}`).pipe(map(res => res as TerceroUPPasarelaTarifa[]));
  }

  guardarPasarelaVersion(registro: TerceroUPPasarelaTarifa) {
    return this.httClient.post(`${this.rutServicio}/pasarelaVersion`, registro).pipe(map(res => res as TerceroUPPasarelaTarifa));
  }
}
